export default __webpack_public_path__ + "static/media/wht-cat-1.9146bf41.svg";